import React from 'react';
import { Tag, Tooltip } from 'antd';
import { WalletOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface HeaderCreditBalanceProps {
  balance: number;
}

/**
 * Header pill that navigates to /credits on click. Wrapped so Tooltip + Tag work reliably.
 */
const HeaderCreditBalance: React.FC<HeaderCreditBalanceProps> = ({ balance }) => {
  const navigate = useNavigate();

  const goToCredits = () => {
    navigate('/credits');
  };

  return (
    <Tooltip title="Your credits — click to manage">
      <span
        role="button"
        tabIndex={0}
        onClick={goToCredits}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            goToCredits();
          }
        }}
        className="inline-flex cursor-pointer align-middle rounded outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-1"
      >
        <Tag
          icon={<WalletOutlined />}
          color={balance > 0 ? 'blue' : 'red'}
          className="text-sm px-3 py-1 m-0 pointer-events-none select-none"
        >
          {balance.toLocaleString()} Credits
        </Tag>
      </span>
    </Tooltip>
  );
};

export default HeaderCreditBalance;
